import React from 'react';
import './ConfigStatus.css';

const ConfigStatus: React.FC = () => {
  const azureOpenAIConfigured = !!(
    process.env.REACT_APP_AZURE_OPENAI_ENDPOINT &&
    process.env.REACT_APP_AZURE_OPENAI_API_KEY &&
    process.env.REACT_APP_AZURE_OPENAI_DEPLOYMENT_NAME
  );

  const azureSearchConfigured = !!(
    process.env.REACT_APP_AZURE_SEARCH_ENDPOINT &&
    process.env.REACT_APP_AZURE_SEARCH_API_KEY &&
    process.env.REACT_APP_AZURE_SEARCH_INDEX_NAME
  );

  const ragEnabled = azureOpenAIConfigured && azureSearchConfigured;

  return (
    <div className="config-status">
      <div className="config-item">
        <span className={`status-indicator ${azureOpenAIConfigured ? 'success' : 'warning'}`}>
          {azureOpenAIConfigured ? '✓' : '⚠'}
        </span>
        <span>Azure OpenAI: {azureOpenAIConfigured ? '已配置' : '未配置'}</span>
      </div>
      
      <div className="config-item">
        <span className={`status-indicator ${azureSearchConfigured ? 'success' : 'warning'}`}>
          {azureSearchConfigured ? '✓' : '⚠'}
        </span>
        <span>Azure 认知搜索: {azureSearchConfigured ? '已配置' : '未配置'}</span>
      </div>
      
      <div className="config-item">
        <span className={`status-indicator ${ragEnabled ? 'success' : 'warning'}`}>
          {ragEnabled ? '✓' : '⚠'}
        </span>
        <span>RAG功能: {ragEnabled ? '已启用' : '未启用'}</span>
      </div>
      
      {ragEnabled && (
        <div className="rag-info">
          <p>🎉 RAG功能已启用！AI将优先使用您的知识库回答问题，当知识库中没有相关信息时会自动使用通用知识回答。</p>
        </div>
      )}
      
      {!ragEnabled && azureOpenAIConfigured && (
        <div className="rag-warning">
          <p>⚠️ 当前使用标准模式。配置Azure认知搜索可启用基于自有数据的增强问答功能。</p>
        </div>
      )}
      
      {!azureOpenAIConfigured && (
        <div className="rag-warning">
          <p>⚠️ 需要配置Azure OpenAI来启用AI聊天功能。</p>
        </div>
      )}
    </div>
  );
};

export default ConfigStatus; 